// extracted by mini-css-extract-plugin
export default {"control":"Checkbox__control--24B","content":"Checkbox__content--5FE","hint":"Checkbox__hint--13Q"};